import { render, staticRenderFns } from "./mainContent.vue?vue&type=template&id=34309084&"
import script from "./mainContent.vue?vue&type=script&lang=js&"
export * from "./mainContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports